import { render, staticRenderFns } from "./AIAssistants.vue?vue&type=template&id=2ded6e7c&scoped=true&"
import script from "./AIAssistants.vue?vue&type=script&lang=js&"
export * from "./AIAssistants.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistants.vue?vue&type=style&index=0&id=2ded6e7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ded6e7c",
  null
  
)

export default component.exports